<mat-form-field
  [class.patient-search-field]="mode !== 'link'"
  appearance="fill"
  [floatLabel]="mode === 'link' ? 'always' : 'never'"
  subscriptSizing="dynamic"
>
  <mat-label *ngIf="mode === 'link'">{{ placeholder || 'SEARCH EXISTING PATIENT' }}</mat-label>
  <input
    type="text"
    [placeholder]="mode === 'link' ? '' : (placeholder || 'LAST, FIRST')"
    matInput
    [formControl]="patientCtrl"
    [matAutocomplete]="auto"
    (keyup.enter)="fixDuplicates ? null : chooseFirstOption()"
    (click)="clickField($event)"
  >
  <mat-checkbox
    *ngIf="canFixDuplicate && mode !== 'link'"
    matSuffix
    class="patient-search-dup-checkbox"
    [(ngModel)]="fixDuplicates"
    [matTooltip]="'Fix Duplicates'"
    aria-label="Fix Duplicates"
  ></mat-checkbox>
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayPatientName" (optionSelected)="onOptionSelected($event)">
    <mat-option *ngFor="let patient of filteredPatients | async" [value]="patient" [class.dns-option]="patient.dns" [disabled]="isOtherStoreDns(patient)" (click)="fixDuplicates || isOtherStoreDns(patient) ? $event.stopPropagation() : null">
      <ng-container *ngIf="fixDuplicates; else noFix">
        <div (click)="isOtherStoreDns(patient) ? $event.preventDefault() : selectModalPatients($event, patient);">
          <mat-checkbox [checked]="selectedPatients.includes(patient)" [disabled]="isOtherStoreDns(patient)">
            {{ patient.lastName }}, {{ patient.firstName }} <span class="dob" *ngIf="patient.dob!=''">({{ patient.dob }})</span> <span class="sleep" *ngIf="patient.sleep"> SLEEP</span> <span class="dns-label" *ngIf="patient.dns">&nbsp;&nbsp;(DNS)<ng-container *ngIf="isOtherStoreDns(patient)">({{ patient.storeAbbreviation }})</ng-container></span>
          </mat-checkbox>
        </div>
      </ng-container>
      <ng-template #noFix>
        {{ patient.lastName }}, {{ patient.firstName }} <span class="dob" *ngIf="patient.dob!=''">({{ patient.dob }})</span> <span class="sleep" *ngIf="patient.sleep"> SLEEP</span> <span class="dns-label" *ngIf="patient.dns">&nbsp;&nbsp;(DNS)<ng-container *ngIf="isOtherStoreDns(patient)">({{ patient.storeAbbreviation }})</ng-container></span>
      </ng-template>
    </mat-option>
    <mat-option *ngIf="!fixDuplicates && mode!='importCustomerImages' && mode!='exams' && mode!='link'" (onSelectionChange)="gotoNewPatient()">
      +NEW CUSTOMER
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
